 <template>
    <div>


                <base-header style="background: rgba(79, 47, 129, 1);
background: radial-gradient(circle, rgba(79, 47, 129, 1) 25%, rgba(79, 47, 129, 0.73) 100%);" class="pb-6 pb-8 pt-5 pt-md-5">
            <!-- Card stats -->
            <!-- <div class="row">
              <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <h3 class="mb-0">Icons</h3>
                        </div>
                        <div class="card-body">
                            <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <base-button type="primary" style="width: 200px; height: 200px;">
                    <center>
                      <p class='ni ni-world'></p>
                      <p style="font-size: 40px;">World</p>
                    </center>
                  </base-button>
                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

                <!-- <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-red"
                                sub-title="350,897"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-orange"
                                sub-title="2,356"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Sales"
                                type="gradient-green"
                                sub-title="924"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Performance"
                                type="gradient-info"
                                sub-title="49,65%"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0"
                    >

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div> -->
            <!-- </div> -->

        </base-header>
<!-- <full-calendar :events="events"></full-calendar> -->

<div id="source-html" style="display: none;">
  <div>
    <img src='https://www.aldarco.com/wp-content/uploads/2020/06/1-300x76.png' height=35 width=125></img>
  </div>
  <br>
  <h3>
    Minutes of meeting
  </h3>
  <!-- <hr> -->
  <br>
  <table style="width:100%">

    <tr>
      <td style="background:#dadada;"><b>Meeting Title</b></td>
      <td>{{this.selectedEvent.title}}</td>
    </tr>
    <tr>
      <td style="background:#dadada;"><b>Meeting Date</b></td>
      <td>{{this.selectedEvent.datetime.split("T")[0]}}</td>
    </tr>
    <tr>
      <td style="background:#dadada;"><b>Meeting Time</b></td>
      <td>From: {{this.selectedEvent.startendtime.split("-")[0]}} To: {{this.selectedEvent.startendtime.split("-")[1]}}</td>
    </tr>
    <tr>
     	<td style="background:#dadada;"><b>Location</b></td>
      <td>{{this.selectedEvent.location}}</td>
    </tr>
    <tr>
      <td style="background:#dadada;"><b>Attendees</b></td>
      <td>
      <ul v-for="attendee in selectedEvent.teamMembers.concat(selectedEvent.committeeMembers)">
        <li>{{attendee}}</li>
        <!-- <li>Tea</li>
        <li>Milk</li> -->
      </ul>
      </td>
    </tr>
  </table>

  <h3>Discussion Points</h3>
<p>
    {{this.selectedEvent.minutes}};

</p>
</div>


<div id="source-html-ar" style="display: none;">
  <div dir="rtl">
    <img src='https://www.aldarco.com/wp-content/uploads/2020/06/1-300x76.png' height=35 width=125></img>
  </div>
  <br>
  <h3 dir="rtl">
    محضر الاجتماع
  </h3>
  <!-- <hr> -->
  <br>
  <table style="width:100%" dir="rtl">

  <tr>
    <td style="background:#dadada;"><b>عنوان الاجتماع</b></td>
    <td>{{this.selectedEvent.title}}</td>
  </tr>
  <tr>
    <td style="background:#dadada;"><b>تاريخ الاجتماع</b></td>
    <td>{{this.selectedEvent.datetime.split("T")[0]}}</td>
  </tr>
  <tr>
    <td style="background:#dadada;"><b>وقت الاجتماع</b></td>
    <td>من: {{this.selectedEvent.startendtime.split("-")[0]}} إلى: {{this.selectedEvent.startendtime.split("-")[1]}}</td>
  </tr>
  <tr>
   	<td style="background:#dadada;"><b>موقع الاجتماع</b></td>
    <td>{{this.selectedEvent.location}}</td>
  </tr>
  <tr>
    <td style="background:#dadada;"><b>الحضور</b></td>
    <td>
      <ul v-for="attendee in selectedEvent.teamMembers.concat(selectedEvent.committeeMembers)">
        <li>{{attendee}}</li>
        <!-- <li>Tea</li>
        <li>Milk</li> -->
      </ul>
    </td>
  </tr>
</table>

<h3 style="text-align:right">مواضيع الاجتماع</h3>
<p style="text-align:right">
    {{this.selectedEvent.minutes}};

</p>
</div>

        <div class="container-fluid mt--7" style="background-color: white;" :dir="language">

            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                          <h3 class="mb-0" v-if="language=='ltr'">{{texts.meetings}}</h3>
                          <h3 class="mb-0" v-else style="text-align:right;">{{texts.meetings}}</h3>
                            <!-- <base-button type="primary" style="float:right;" v-on:click="switchView()">{{texts.switchview}}</base-button> -->
                        </div>
                    <div class="card-body">
                      <modal :show.sync="modals.modal0" style="
    overflow-y: auto;">
                       <template slot="header">
                         <div v-if="language=='ltr'">
                          <span style="font-size: 24px; color: black;width:85%;"  id="exampleModalLabel" v-if="!isEditingMeeting">{{texts.createnewmeeting}}</span>
                          <span style="font-size: 24px; color: black;width:85%;"  id="exampleModalLabel" v-else>{{texts.editmeetings}}</span>
                          </div>
                          <div v-else>
                           <span style="font-size: 24px; color: black;width:85%;text-align:right;"  id="exampleModalLabel" v-if="!isEditingMeeting">{{texts.createnewmeeting}}</span>
                           <span style="font-size: 24px; color: black;width:85%;text-align:right;"  id="exampleModalLabel" v-else>{{texts.editmeetings}}</span>
                           </div>
                       </template>
                       <div>
                        <base-input v-if="language=='ltr'" placeholder="Title"
                                        type="text"
                                        v-model="meeting_title" style="width: 85%"
                                        >
                            </base-input>
                            <base-input v-else placeholder="العنوان"
                                            type="text"
                                            v-model="meeting_title" style="width: 85%"
                                            >
                                </base-input>

                             <textarea v-if="language=='ltr'" class="form-control"  placeholder="Description"
                                        type="text"
                                        v-model="meeting_description" style="width: 85%"
                                        >
                            </textarea>
                            <textarea v-else  class="form-control"  placeholder="الوصف"
                                       type="text"
                                       v-model="meeting_description" style="width: 85%"
                                       >
                           </textarea>
                            <br>
                            <div v-if="language =='ltr'">
                              <span>Start Time : </span>
                                <a-time-picker @openChange="handleOpenChange" :open="open" format="HH:mm" v-model="meeting_start_time" >
                                  <a-button slot="addon" slot-scope="panel" size="small" type="primary" @click="handleClose"
                                    >{{texts.confirm}}</a-button
                                  >
                                </a-time-picker>
                                <span>  End Time : </span>
                                <a-time-picker :open.sync="open2" format="HH:mm" v-model="meeting_end_time">
                                  <a-button slot="addon"  size="small" type="primary" @click="handleClose">{{texts.confirm}}</a-button>
                                </a-time-picker>
                              </div>

                              <div v-else class="text-right">
                                <span>{{texts.startime}} : </span>
                                  <a-time-picker dir="ltr" @openChange="handleOpenChange" :open="open" format="HH:mm" v-model="meeting_start_time" placeholder="حدد الوقت" >
                                    <a-button slot="addon" slot-scope="panel" size="small" type="primary" @click="handleClose"
                                      >{{texts.confirm}}</a-button
                                    >
                                  </a-time-picker>
                                  <span>  {{texts.endtime}} : </span>
                                  <a-time-picker dir="ltr" :open.sync="open2" format="HH:mm" v-model="meeting_end_time" placeholder="حدد الوقت">
                                    <a-button slot="addon"  size="small" type="primary" @click="handleClose">{{texts.confirm}}</a-button>
                                  </a-time-picker>
                                </div>
                            </br>
                            <div v-if="isEditingMeeting" >
                            <!-- <div class="col-md-4"> -->
                            <div v-if="language =='ltr'" class="col-md-4" style="padding : 0px;">
                              <span>Meeting Date : </span>
                              <base-input >
                              <flat-picker id="meetingDate" slot-scope="{focus, blur}"
                                           @on-open="focus"
                                           @on-close="blur"
                                           :config="{allowInput: true}"
                                           class="form-control datepicker"
                                           v-model="create_meeting_date" style="font-size: 12px;height: 43px;"
                                           @on-change="onChange()">
                              </flat-picker>
                              </base-input>
                            </div>
                            <div v-else class="text-right col-md-4" style="padding : 0px;">
                              <span>تاريخ الاجتماع</span>
                              <base-input>
                              <flat-picker id="meetingDate" slot-scope="{focus, blur}"
                                           @on-open="focus"
                                           @on-close="blur"
                                           :config="{allowInput: true}"
                                           class="form-control datepicker"

                                           v-model="create_meeting_date" style="font-size: 12px;height: 43px;"
                                           @on-change="onChange()">
                              </flat-picker>
                              </base-input>
                            </div>
                            </div>
                             <base-input v-if="language=='ltr'" placeholder="Location"
                                        type="text"
                                        v-model="meeting_location" style="width: 85%"
                                        >
                            </base-input>
                            <base-input v-else placeholder="الموقع"
                                       type="text"
                                       v-model="meeting_location" style="width: 85%"
                                       >
                           </base-input>


                            <h3 v-if="language === 'ltr'">{{texts.committeemembers}}</h3>
                            <h3 v-else style="text-align :right;">{{texts.committeemembers}}</h3>
                            <div class="row">
                              <div class="col-md-6" v-for="(fieldName, pos1) in committeemembers">
                           <base-checkbox  class="mb-3"  v-if="language == 'ltr'" :key="pos1" v-model="committeemembers[pos1].checked">
                                  {{fieldName.name}}
                              </base-checkbox>

                              <base-checkbox  class="mb-3 text-right"  v-else :key="pos1" v-model="committeemembers[pos1].checked">
                                     {{fieldName.name}}
                                 </base-checkbox>
                              </div>
                              </div>
                               <!-- <base-checkbox v-if="language == 'ltr'" class="mb-3" v-for="(fieldName, pos1) in committeemembers" :key="pos1" v-model="committeemembers[pos1].checked">
                                    {{fieldName.name}}
                                </base-checkbox>
                                <base-checkbox v-else class="mb-3 text-right" v-for="(fieldName, pos1) in committeemembers" :key="pos1" v-model="committeemembers[pos1].checked">
                                     {{fieldName.name}}
                                 </base-checkbox> -->

                            <h3 v-if="language === 'ltr'">{{texts.teammembers}}</h3>
                            <h3 v-else style="text-align :right;">{{texts.teammembers}}</h3>
                            <div class="row">
                              <div class="col-md-6" v-for="(fieldName, pos1) in teammembers">
                           <base-checkbox  class="mb-3"  v-if="language == 'ltr'" :key="pos1" v-model="teammembers[pos1].checked">
                                  {{fieldName.name}}
                              </base-checkbox>

                              <base-checkbox  class="mb-3 text-right"  v-else :key="pos1" v-model="teammembers[pos1].checked">
                                     {{fieldName.name}}
                                 </base-checkbox>
                              </div>
                              </div>
                               <!-- <base-checkbox v-if="language == 'ltr'" class="mb-3" v-for="(fieldName, pos1) in teammembers" :key="pos1" v-model="teammembers[pos1].checked">
                                    {{fieldName.name}}
                                </base-checkbox>
                                <base-checkbox v-else  class="mb-3 text-right" v-for="(fieldName, pos1) in teammembers" :key="pos1" v-model="teammembers[pos1].checked">
                                     {{fieldName.name}}
                                 </base-checkbox> -->

                       </div>
                       <template slot="footer">
                           <base-button type="secondary" @click="modals.modal0 = false">{{texts.close}}</base-button>
                           <base-button type="primary" v-on:click="createMeeting" v-if="!isEditingMeeting">{{texts.createmeeting}}</base-button>
                           <base-button type="primary" v-on:click="submitEditMeeting" v-else >{{texts.editmeetings}}</base-button>
                       </template>
                      </modal>

                      <modal :show.sync="modals.modal1" dir="ltr">
                       <template slot="header">
                          <span v-if="language == 'ltr'" style="font-size: 24px; color: black;width:85%;" id="exampleModalLabel">{{selectedEvent.title}}</span>
                          <span v-else style="text-align : right;font-size: 24px; color: black;width:85%;" id="exampleModalLabel">{{selectedEvent.title}}</span>
                       </template>
                       <div>

                       <h4 v-if="language == 'ltr'">{{texts.description}}</h4>
                       <h4 v-else style="text-align : right;">{{texts.description}}</h4>
                       <p v-if="language == 'ltr'" style="font-family: 'Open Sans', sans-serif, Helvetica">{{selectedEvent.description}}</p>
                       <p v-else style="text-align : right;font-family: 'Open Sans', sans-serif, Helvetica">{{selectedEvent.description}}</p>

                       <h4 v-if="language == 'ltr'">{{texts.location}}</h4>
                       <h4 v-else style="text-align : right;">{{texts.location}}</h4>
                       <p v-if="language == 'ltr'" style="font-family: 'Open Sans', sans-serif, Helvetica"><i class="ni ni-pin-3"></i> <a v-if="String(selectedEvent.location).includes('http') || String(selectedEvent.location).includes('www') || String(selectedEvent.location).includes('com') || String(selectedEvent.location).includes('co')" :href="selectedEvent.location" target="_blank">{{selectedEvent.location}}</a>
                        <a v-else>{{selectedEvent.location}}</a>
                       <p v-else style="text-align : right;font-family: 'Open Sans', sans-serif, Helvetica"><i class="ni ni-pin-3"></i> <a v-if="String(selectedEvent.location).includes('http') || String(selectedEvent.location).includes('www') || String(selectedEvent.location).includes('com') || String(selectedEvent.location).includes('co')" :href="selectedEvent.location" target="_blank">{{selectedEvent.location}}</a>
                        <a v-else>{{selectedEvent.location}}</a>

                       <h4 v-if="language == 'ltr'">{{texts.time}}</h4>
                       <h4 v-else style="text-align : right;">{{texts.time}}</h4>
                       <p v-if="language == 'ltr'" style="font-family: 'Open Sans', sans-serif, Helvetica"><i class="ni ni-time-alarm"></i>{{selectedEvent.startendtime}}</p>
                       <p v-else style="text-align : right;font-family: 'Open Sans', sans-serif, Helvetica"><i class="ni ni-time-alarm"></i>{{selectedEvent.startendtime}}</p>

                       <div v-if="language=='ltr'">
                       <base-button v-bind:style= "[language == 'ltr' ?  {'text-align':'left;'} : {'text-align':'right;'}]" v-if="selectedEvent.hasMinutes && selectedEvent.areMinutesApproved" type="button" class="btn btn-primary btn-sm"  @click="modals.modal2 = true">{{texts.viewminutes}}</base-button>
                       <base-button v-bind:style= "[language == 'ltr' ?  {'text-align':'left;'} : {'text-align':'right;'}]" v-else-if="selectedEvent.hasMinutes && !selectedEvent.areMinutesApproved && isManager && isTeam" type="button" class="btn btn-primary btn-sm"  @click="modals.modal3 = true">{{texts.editandapproveminutes}}</base-button>
                       <base-button v-bind:style= "[language == 'ltr' ?  {'text-align':'left;'} : {'text-align':'right;'}]" v-else-if="selectedEvent.hasMinutes && !selectedEvent.areMinutesApproved && !isManager && isTeam" type="button" class="btn btn-primary btn-sm"  @click="modals.modal3 = true">{{texts.editminutes}}</base-button>
                       <base-button v-bind:style= "[language == 'ltr' ?  {'text-align':'left;'} : {'text-align':'right;'}]" v-else-if="!selectedEvent.hasMinutes && !selectedEvent.areMinutesApproved && isTeam" type="primary" class="btn btn-primary btn-sm"  @click="modals.modal3 = true;selectedEvent.minutes = '';" >{{texts.addminutes}}</base-button>

                       <div v-else ></div>

                        <base-button v-bind:style= "[language == 'ltr' ?  {'text-align':'left;'} : {'text-align':'right;'}]" v-if="selectedEvent.hasMinutes && selectedEvent.areMinutesApproved" type="button" class="btn btn-primary btn-sm"  @click="exportMinutes()">{{texts.exportminutes}}</base-button>

                        <!-- <button id="download_link"  v-on:click='downloadFile("http://localhost:8090/api/v1/minutesfile/5ed8cb1976307226a6036a7d", "fileName.pdf")' >Download attached file</button> -->
                        <base-button v-bind:style= "[language == 'ltr' ?  {'text-align':'left;'} : {'text-align':'right;'}]" v-if="(new Date(selectedEvent.datetime) > new Date() || (new Date(selectedEvent.datetime).getDate()== new Date().getDate() && new Date(selectedEvent.datetime).getMonth() == new Date().getMonth())) &&  isManager" type="button" class="btn btn-primary btn-sm"  @click="editMeeting(selectedEvent)">{{texts.editmeetings}}</base-button>
                        <!-- <base-button v-bind:style= "[language == 'ltr' ?  {'text-align':'left;'} : {'text-align':'right;'}]" v-if="new Date(selectedEvent.datetime) > new Date() && isManager" type="button" class="btn btn-primary btn-sm"  @click="editMeeting(selectedEvent)">{{texts.editmeetings}}</base-button> -->
                        <div style="margin-top:10px;">
                        <base-button v-bind:style= "[language == 'ltr' ?  {'text-align':'left;margin-top:10px;'} : {'text-align':'right;margin-top:10px;'}]" v-if="(new Date(selectedEvent.datetime) > new Date() || (new Date(selectedEvent.datetime).getDate()== new Date().getDate() && new Date(selectedEvent.datetime).getMonth() == new Date().getMonth())) && isManager" type="button" class="btn btn-warning btn-sm"  @click="modals.modal14 = true;">{{texts.deletemeeting}}</base-button>
                        </div>
                        <br><br>
                        <a v-bind:style= "[language == 'ltr' ?  {'text-align':'left;'} : {'text-align':'right;'}]"
                          v-if="(selectedEvent.hasFile && selectedEvent.areMinutesApproved) || (selectedEvent.hasFile && isManager)"
                          :href="item.url"
                          v-text="texts.download_file"
                          @click.prevent="downloadItem(item)" />
                       </div>
                       <div v-else style="text-align:right;">
                       <base-button v-bind:style= "[language == 'ltr' ?  {'text-align':'left;'} : {'text-align':'right;'}]" v-if="selectedEvent.hasMinutes && selectedEvent.areMinutesApproved" type="button" class="btn btn-primary btn-sm"  @click="modals.modal2 = true">{{texts.viewminutes}}</base-button>
                       <base-button v-bind:style= "[language == 'ltr' ?  {'text-align':'left;'} : {'text-align':'right;'}]" v-else-if="selectedEvent.hasMinutes && !selectedEvent.areMinutesApproved && isManager && isTeam" type="button" class="btn btn-primary btn-sm"  @click="modals.modal3 = true">{{texts.editandapproveminutes}}</base-button>
                       <base-button v-bind:style= "[language == 'ltr' ?  {'text-align':'left;'} : {'text-align':'right;'}]" v-else-if="selectedEvent.hasMinutes && !selectedEvent.areMinutesApproved && !isManager && isTeam" type="button" class="btn btn-primary btn-sm"  @click="modals.modal3 = true">{{texts.editminutes}}</base-button>
                       <base-button v-bind:style= "[language == 'ltr' ?  {'text-align':'left;'} : {'text-align':'right;'}]" v-else-if="!selectedEvent.hasMinutes && !selectedEvent.areMinutesApproved && isTeam" type="primary" class="btn btn-primary btn-sm"  @click="modals.modal3 = true;selectedEvent.minutes = '';" >{{texts.addminutes}}</base-button>

                       <div v-else ></div>

                        <base-button v-bind:style= "[language == 'ltr' ?  {'text-align':'left;'} : {'text-align':'right;'}]" v-if="selectedEvent.hasMinutes && selectedEvent.areMinutesApproved" type="button" class="btn btn-primary btn-sm"  @click="exportMinutes()">{{texts.exportminutes}}</base-button>

                        <!-- <button id="download_link"  v-on:click='downloadFile("http://localhost:8090/api/v1/minutesfile/5ed8cb1976307226a6036a7d", "fileName.pdf")' >Download attached file</button> -->
                        <base-button v-bind:style= "[language == 'ltr' ?  {'text-align':'left;'} : {'text-align':'right;'}]" v-if="(new Date(selectedEvent.datetime) > new Date() || (new Date(selectedEvent.datetime).getDate()== new Date().getDate() && new Date(selectedEvent.datetime).getMonth() == new Date().getMonth())) &&  isManager" type="button" class="btn btn-primary btn-sm"  @click="editMeeting(selectedEvent)">{{texts.editmeetings}}</base-button>
                        <!-- <base-button v-bind:style= "[language == 'ltr' ?  {'text-align':'left;'} : {'text-align':'right;'}]" v-if="new Date(selectedEvent.datetime) > new Date() && isManager" type="button" class="btn btn-primary btn-sm"  @click="editMeeting(selectedEvent)">{{texts.editmeetings}}</base-button> -->
                        <div style="margin-top:10px;">
                          <base-button v-bind:style= "[language == 'ltr' ?  {'text-align':'left;margin-top:10px;'} : {'text-align':'right;margin-top:10px;'}]" v-if="(new Date(selectedEvent.datetime) > new Date() || (new Date(selectedEvent.datetime).getDate()== new Date().getDate() && new Date(selectedEvent.datetime).getMonth() == new Date().getMonth())) && isManager" type="button" class="btn btn-warning btn-sm"  @click="modals.modal14 = true;">{{texts.deletemeeting}}</base-button>
                        </div>
                        <br><br>
                        <a v-bind:style= "[language == 'ltr' ?  {'text-align':'left;'} : {'text-align':'right;'}]"
                          v-if="(selectedEvent.hasFile && selectedEvent.areMinutesApproved) || (selectedEvent.hasFile && isManager)"
                          :href="item.url"
                          v-text="texts.download_file"
                          @click.prevent="downloadItem(item)" />
                       </div>
                       </div>
                       <template slot="footer">
                           <base-button type="secondary" @click="modals.modal1 = false">{{texts.close}}</base-button>

                       </template>
                      </modal>

                      <modal :show.sync="modals.modal2">
                      <template slot="header">
                         <span v-if="language =='ltr'" style="font-size: 24px; color: black;width:85%;" id="exampleModalLabel">{{selectedEvent.title}} Minutes</span>
                         <span v-else style="text-align:right;font-size: 24px; color: black;width:85%;" id="exampleModalLabel">{{selectedEvent.title}} محضر الاجتماع</span>
                      </template>
                      <h4 v-if="language=='ltr'">Minutes</h4>
                      <h4 v-else style="text-align:right;">محضر الاجتماع</h4>
                      <div v-if="language=='ltr'" style="overflow-y: scroll; height:300px;">
                       <p style="white-space: pre-line;">{{selectedEvent.minutes}}</p>



                      </div>
                      <div v-else style="overflow-y: scroll; height:300px;text-align:right;">
                       <p style="white-space: pre-line;">{{selectedEvent.minutes}}</p>



                      </div>
                      <template slot="footer">
                          <base-button type="secondary" @click="modals.modal2 = false">{{texts.close}}</base-button>

                      </template>
                     </modal>


                       <modal :show.sync="modals.modal3">
                       <template slot="header">
                          <span style="font-size: 24px; color: black;width:85%;" id="exampleModalLabel">{{selectedEvent.title}} - {{texts.addminutes}}</span>
                       </template>
                       <div>
                       <textarea v-if="language == 'ltr'" class="form-control"  placeholder="Minutes.."
                                        type="text"
                                        v-model="selectedEvent.minutes" rows="10"
                                        >
                            </textarea>
                            <textarea v-else class="form-control"  placeholder="محضر الاجتماع .."
                                             type="text"
                                             v-model="selectedEvent.minutes" rows="10"
                                             >
                                 </textarea>
                                 <br>
                                 <div v-if="language == 'ltr'">
                                   <input style="text-align : right;" ref="file" type="file" name="MoMFile" accept="application/pdf" v-on:change="onSelect"/>
                                 </div>
                                 <div v-else style="text-align : right;">
                                   <input style="text-align : right;" ref="file" type="file" name="MoMFile" accept="application/pdf" v-on:change="onSelect"/>
                                 </div>



                       </div>
                       <template slot="footer">
                           <base-button type="secondary" @click="modals.modal3=0;">{{texts.close}}</base-button>
                           <base-button type="primary" @click="saveMinutes()">{{texts.saveminutes}}</base-button>
                           <base-button v-if="isManager" @click="approveMinutes()" type="primary">{{texts.approveminutes}}</base-button>

                       </template>
                      </modal>



                        <div v-if="isCalendarView" style="background-color: white; z-index: -999;">

                        <FullCalendar v-on:dateClick="handleDateClick" v-on:eventClick="eventClick" :header="{
                              left: 'prev,next today',
                              center: 'title',
                              right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
                            }"
                        defaultView="dayGridMonth" :events="meetings" :buttonText="buttonText" eventTextColor="#ffff" eventBorderColor="rgba(79, 47, 129, 1);" eventBackgroundColor="rgba(79, 47, 129, 1);" :plugins="calendarPlugins" />
                        </div>
                        <!-- <div class ="row" v-else> -->
                          <meetings-table v-else title="Progress" :tableData="meetings" @view="viewMeeting($event)"></meetings-table>
                          <!-- <card class="col-md-4" v-for="meeting in meetings" header-classes="bg-white" style="background-color: white;background: #fff; margin-right:0px;margin-top:8px;" :dir="language">

                            <div class="row" :dir="language">
                              <div class="col-8">
                              <h1 class="mb-0" style="margin-top:-20px;">{{meeting.title}}</h1>
                              </div>

                              <div class="col-8">
                              <h4>{{texts.description}}</h4>
                              <span>{{meeting.description}}<br></span>
                              </div>
                              <br>

                              <div class="col-8">
                                <h4>{{texts.date}}</h4>
                              <span >{{meeting.start.split("T")[0].replace(/-/g,"/")}}</span>
                              </div>
                              <div class="col-4">
                              <button type="button" style="float: right;" class="btn btn-primary" v-on:click="meetingClick(meeting)">{{texts.view}}</button>
                              </div>
                            </div>
                          </card> -->
                          <!-- <br> -->
                        <!-- </div> -->
<!--                          <div style="  z-index: 1;
">
          <beautiful-chat
          style="z-index: 1"
            :participants="participants"
            :titleImageUrl="titleImageUrl"
            :onMessageWasSent="onMessageWasSent"
            :messageList="messageList"
            :newMessagesCount="newMessagesCount"
            :isOpen="isChatOpen"
            :close="closeChat"
            :icons="icons"
            :open="openChat"
            :showEmoji="true"
            :showFile="true"
            :showTypingIndicator="showTypingIndicator"
            :colors="colors"
            :alwaysScrollToBottom="alwaysScrollToBottom"
            :messageStyling="messageStyling"
            v-on:onType="handleOnType"
            v-on:edit="editMessage" />
        </div> -->
        <!-- <div style="z-index: 1;position: relative;">
          <base-button class="btn-primary"  icon="ni ni-chat-round" style='position: fixed;bottom: 27px;right: 15px;height:44px;border-radius:50px;font-size:15px;background-color: rgb(79, 47, 129);' v-on:click="openChatModal">{{texts.chats}}</base-button>
        </div> -->
         <div>
           <!-- SHOW FILE WASS SET TO FALSE -->
          <beautiful-chat style="z-index: 1;position: relative" v-if="isChatHidden" id="chat"
            :participants="participants"
            :titleImageUrl="titleImageUrl"
            :onMessageWasSent="onMessageWasSent"
            :messageList="messageList"
            :newMessagesCount="newMessagesCount"
            :isOpen="isChatOpen"
            :close="closeChat"
            :icons="icons"
            :open="openChat"
            :showEmoji="true"
            :showFile="false"
            :showTypingIndicator="showTypingIndicator"
            :colors="colors"
            :alwaysScrollToBottom="alwaysScrollToBottom"
            :messageStyling="messageStyling"
            v-on:onType="handleOnType"
            v-on:edit="editMessage" />
        </div>
        <modal id="chatsModal" :show.sync="modals.modal9" dir="ltr">
        <template slot="header">
           <span style="font-size: 24px; color: black;width:85%;" id="exampleModalLabel">{{texts.chats}}</span>
        </template>
          <div style="overflow-y: scroll; height:400px;">
          <card v-for="chat in chats" header-classes="bg-white" style="background-color: white;background: #fff;" >
            <div class="row">
              <div v-if="true" class="col-1" style="margin-top:-12px;">
              <badge v-if="chat.notifications > 0" type="danger" style="background:red;color:#fff;font-size: 14px;border-radius:50px;width:26px;height:26px;margin-left:-10px;">{{chat.notifications}}</badge>
              </div>

              <h2 class="col-7" style="margin-top:-10px;">{{chat.title}}</h2><div class="col-4"  style="width: 100%; margin-top:-15px;">

              <button type="button" style="float: right;margin-top: 10px;" class="btn btn-primary" v-on:click="onClick(chat)">{{texts.view}}</button>

                </div>
              <!-- <br> -->
              <span class="col-8" style="font-size:16px;">{{chat.message.data.text}}</span>
              <br>
              <br>
              <span class="col-8" style="font-size:12px;">Received : {{chat.message.data.meta}}</span>

              <span class="col-8" style="margin-top:15px;margin-left:-6px;margin-bottom:-6px;"><badge type="primary" style="margin-left: 5px;border-radius:50px;">{{chat.participantsDisplay}}</badge></span>
            </div>
          </card>



        </div>
        <template slot="footer" style="justify-content:centered;">
            <base-button type="primary"  icon="ni ni-fat-add" style="font-size:13px;border-radius:50px;" @click="newPublicChat()">{{texts.publicchat}}</base-button>
            <base-button type="info" icon="ni ni-fat-add" style="font-size:13px;border-radius:50px;"  @click="newPrivateChat()">{{texts.privatechat}}</base-button>
            <base-button type="secondary" @click="modals.modal9 = false" style="margin-left:50px;">{{texts.close}}</base-button>
        </template>
       </modal>

       <modal :show.sync="modals.modal14">
               <template slot="header">
                  <span style="font-size: 24px; color: black;" v-if="language =='ltr'" id="exampleModalLabel">Confirmation</span>
                  <span style="font-size: 24px; color: black;text-align:right;" v-else id="exampleModalLabel">تأكيد</span>
               </template>
               <div>

               <p style="font-family: 'Open Sans', sans-serif, Helvetica" v-if="language=='ltr'">Are you sure you want to delete the meeting ?</p>
               <p style="font-family: 'Open Sans', sans-serif, Helvetica; text-align:right;" v-else >هل أنت متأكد أنك تريد حذف الاجتماع؟</p>

               </div>
               <template slot="footer">

                   <base-button type="secondary" @click="modals.modal14 = false" v-if="language=='ltr'">Cancel</base-button>
                   <base-button type="secondary" @click="modals.modal14 = false" v-else >إلغاء</base-button>
                  <base-button type="secondary" @click="deleteMeeting()" v-if="language=='ltr'">Confirm</base-button>
                  <base-button type="secondary" @click="deleteMeeting()" v-else >نعم</base-button>

               </template>
              </modal>

                      </div>


                    </div>

              </div>

            </div>

          </div>

        </div>



       <!--  <div class="container-fluid mt--7" style="background-color: white;">
            <div class="row" style="background-color: white;">
                <div class="col">
                  <h1>lol</h1>
                    <FullCalendar v-on:dateClick="handleDateClick" defaultView="dayGridMonth"  :plugins="calendarPlugins" />
                </div>
            </div>
        </div> -->


    </div>


    <!-- <div class="content-footer">
        <button id="btn-export" onclick="exportHTML();">Export to
            word doc</button>
    </div> -->


</template>


<script src="https://jspdf.netlify.com/trado-normal.js"></script>

<script>
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
import MeetingsTable from './Tables/MeetingsTable';
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from "@fullcalendar/timegrid";
  import CloseIcon from 'vue-beautiful-chat/src/assets/close-icon.png'
  import OpenIcon from 'vue-beautiful-chat/src/assets/logo-no-bg.svg'
  import FileIcon from 'vue-beautiful-chat/src/assets/file.svg'
  import CloseIconSvg from 'vue-beautiful-chat/src/assets/close.svg'
import { GET_TEAM_MEMBERS,GET_COMMITTEE_MEMBERS,CREATE_MEETING, GET_MEETINGS, SAVE_MINUTES, APPROVE_MINUTES, CREATE_CHAT, GET_CHATS, SEND_MESSAGE, EDIT_MEETING, DELETE_MEETING, SAVE_MINUTES_WITH_FILE } from "@/store/actions.type";
import store from "@/store";
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import UserService from "@/common/user.service";
import JwtService from "@/common/jwt.service";
import jsPDF from 'jspdf'
import axios from "axios";
import VueAxios from "vue-axios";
import Vue from "vue";
import { API_URL } from "@/common/config";
export default {
  components: {
    FullCalendar, MeetingsTable, flatPicker // make the <FullCalendar> tag available
  },
  data() {
    return {
      texts : {
        meetings : UserService.getLanguage() === "rtl" ? "الإجتماعات" : "Meetings",
        register : UserService.getLanguage() === "rtl" ? "تسجيل" : "Register",
        phonenumber : UserService.getLanguage() === "rtl" ? "رقم الهاتف" : "Phone Number",
        title : UserService.getLanguage() === "rtl" ? "المسمى الوظيفي" : "Title",
        newpass : UserService.getLanguage() === "rtl" ? "كلمة السر الجديدة" : "New Password",
        description : UserService.getLanguage() === "rtl" ? "الوصف" : "Description",
        location : UserService.getLanguage() === "rtl" ? "الموقع" : "Location",
        time : UserService.getLanguage() === "rtl" ? "الوقت" : "Time",
        createnewmeeting : UserService.getLanguage() === "rtl" ? "إنشاء اجتماع جديد": "Create New Meeting",
        createmeeting : UserService.getLanguage() === "rtl" ? "إنشاء اجتماع": "Create Meeting",
        saveminutes : UserService.getLanguage() === "rtl" ? "حفظ محضر الاجتماع" : "Save Minutes",
        editandapproveminutes : UserService.getLanguage() === "rtl" ? "تعديل والموافقة محضر الاجتماع" : "Edit & Approve Minutes",
        approveminutes : UserService.getLanguage() === "rtl" ? "موافقة محضر الاجتماع" : "Approve Minutes",
        editminutes : UserService.getLanguage() === "rtl" ? "تعديل محضر الاجتماع" : "Edit Minutes",
        addminutes : UserService.getLanguage() === "rtl" ? "إضافة محضر الاجتماع" : "Add Minutes",
        viewminutes : UserService.getLanguage() === "rtl" ? "استعراض محضر الاجتماع" : "View Minutes",
        minutes : UserService.getLanguage() === "rtl" ? "محضر الاجتماع" : "Minutes",
        exportminutes : UserService.getLanguage() === "rtl" ? "تنزيل محضر الاجتماع" : "Download Minutes",
        editmeetings : UserService.getLanguage() === "rtl" ? "تعديل الاجتماع" : "Edit Meeting",
        close : UserService.getLanguage() === "rtl" ? "إغلاق" : "Close",
        chats : UserService.getLanguage() === "rtl" ? ".  محادثات" : "Chats",
        view : UserService.getLanguage() === "rtl" ? "عرض" : "View",
        publicchat : UserService.getLanguage() === "rtl" ? "محادثة عامة" : "Public Chat",
        privatechat : UserService.getLanguage() === "rtl" ? "محادثة خاصة" : "Private Chat",
        switchview : UserService.getLanguage() === "rtl" ? "قائمة الاجتماعات" : "List of meetings",
        date : UserService.getLanguage() === "rtl" ? "التاريخ" : "Date",
        committeemembers :UserService.getLanguage() === "rtl" ? "ممثلو العميل" : "Client Representatives",
        teammembers : UserService.getLanguage() === "rtl" ? "أعضاء الفريق" : "Team Members",
        startime : UserService.getLanguage() === "rtl" ? "وقت البدء" : "Start Time",
        endtime : UserService.getLanguage() === "rtl" ? "وقت النهاية" : "End Time",
        confirm : UserService.getLanguage() === "rtl" ? "تأكيد" : "Confirm",
        deletemeeting : UserService.getLanguage() === "rtl" ? "حذف الاجتماع" : "Delete Meeting",
        download_file : UserService.getLanguage() === "rtl" ? "تحميل الملف المرفق" : "Download Attached File",
        calendar: UserService.getLanguage() === "rtl" ? "التقويم": "Calendar",
        list_of_meetings: UserService.getLanguage() === "rtl" ?  "قائمة الاجتماعات" : "List of Meetings"
      },
      item: {
        label : "hello",
        url : "http://localhost:8090/api/v1/minutesfile/5ed8cb1976307226a6036a7d"
      },
      file : '',
      isCalendarView : false,
      isChatHidden : true,
      chats : [],
      isNewChat : false,
      chatId : "",
      chatType : "",
      chatTitle : "",

      language : UserService.getLanguage() || "ltr",
      userType : JwtService.getUserType(),
      isTeam : JwtService.getUserType() === "team",
      isManager : JwtService.getIsManager() === 1 ? true : false,
      timeslot : "8:00-10:00",
      calendarEvents : [
      { title: "Quarterly Committee Meeting", start: new Date("2019-12-02 12:00"), end: new Date("2019-12-02 14:00")}
      ],
      calendarPlugins: [ dayGridPlugin, interactionPlugin, timeGridPlugin ],
      meeting_title : "",
      meeting_description : "",
      meeting_location : "",
      meeting_start_time : "",
      meeting_end_time : "",
      create_meeting_date : "",
      isEditingMeeting : false,
      teammembers : [],
      committeemembers : [],
      isCreatingMeeting : false,
      modals: {
        modal0 : false,
        modal1 : false,
        modal2 : false,
        modal3 : false,
        modal9 : false,
        modal14 : false
      },
       open: false,
        open2: false,
      selectedEvent : {
        id : "",
        title : "",
        minutes : "",
        description  : "",
        startendtime : "",
        hasMinutes : false,
        areMinutesApproved : false,
        datetime : "",
        teamMembers : [],
        committeeMembers : [],
        hasFile : 0
      },
      buttonText : {
        today:    UserService.getLanguage() === "rtl" ? "اليوم" : 'Today',
        month:    UserService.getLanguage() === "rtl" ? "شهر" : 'Month',
        week:     UserService.getLanguage() === "rtl" ? "أسبوع" : 'Week',
        day:      UserService.getLanguage() === "rtl" ? "يوم" : 'Day',
        list:     UserService.getLanguage() === "rtl" ? "قائمة" : 'List'
      },
       icons:{
        open:{
          img: OpenIcon,
          name: 'default',
        },
        close:{
          img: CloseIcon,
          name: 'default',
        },
        file:{
          img: FileIcon,
          name: 'default',
        },
        closeSvg:{
          img: CloseIconSvg,
          name: 'default',
        },
      },
      participants: [
        // {
        //   id: 'user1',
        //   name: 'Othman Barakat',
        //   imageUrl: 'https://avatars3.githubusercontent.com/u/1915989?s=230&v=4'
        // },
        // {
        //   id: 'user2',
        //   name: 'Nasser Barakat',
        //   imageUrl: 'https://avatars3.githubusercontent.com/u/1915989?s=230&v=4'
        // }
      ], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
      titleImageUrl: 'https://a.slack-edge.com/66f9/img/avatars-teams/ava_0001-34.png',
      messageList: [
          // { type: 'text', author: `me`, data: { text: `Regarding the risk assessment report for phase 1, why is there a lack of documentation about the reported case on page 4 ?`,  meta: '06-16-2019 12:43' } },
          // { type: 'text', author: `user1`, data: { text: `Dear Mr. Ahmad, we have looked into your enquiry and found that indeed there was a lack of documentation. We shall update the report.` } }
      ], // the list of the messages to show, can be paginated and adjusted dynamically
      suggestions: ['some quick reply', 'another one'],
      newMessagesCount: 0,
      isChatOpen: false, // to determine whether the chat window should be open or closed
      showTypingIndicator: '', // when set to a value matching the participant.id it shows the typing indicator for the specific user
      colors: {
        header: {
          bg: '#4f2f81',
          text: '#ffffff'
        },
        launcher: {
          bg: '#4f2f81'
        },
        messageList: {
          bg: '#ffffff'
        },
        sentMessage: {
          bg: '#4f2f81',
          text: '#ffffff'
        },
        receivedMessage: {
          bg: '#eaeaea',
          text: '#222222'
        },
        userInput: {
          bg: '#f4f7f9',
          text: '#565867'
        }
      }, // specifies the color scheme for the component
      alwaysScrollToBottom: false, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
      messageStyling: true



  }},

   computed: {
        ...mapGetters(["isAuthenticated", "meetings"])
        // ,
        // subscribers() {
        //     console.log(this.$route.params.subscribers);
        //   return this.$route.params.subscribers;
        // }
      },
  mounted() {
    if (sessionStorage.getItem('reloaded') != null) {
    console.log('page was reloaded');
} else {
  this.$router.push({ name: "login" })
    console.log('page was not reloaded');
}
    document.getElementById("chatsModal").childNodes[0].style = 'margin-right : 75px;background-color: #ffffff;';
    document.getElementById("chat").style.visibility = "hidden";
    document.getElementById("chat").childNodes[0].style="margin-right:125px;background-color: rgb(79, 47, 129);";
    document.getElementById("chat").childNodes[0].childNodes[0].style="margin-right:125px;";
    document.getElementById("chat").childNodes[0].childNodes[1].style="margin-right:125px;";
    console.log("IS MANAGER : " + this.isManager);

    Promise.all([

        store.dispatch(GET_COMMITTEE_MEMBERS, UserService.getAssignmentId()),
        store.dispatch(GET_MEETINGS, UserService.getAssignmentId()),
      ]).then((data) => {
        console.log(data[0]['data']);
          this.loaded = true;

          // console.log(store.getters.teamMembers);
          this.committeemembers = data[0]['data'];
          // this.teammembers = teamMembers;
          // console.log(this.stores);
          // console.log(this.visitsdata);
          // this.initBigChart(this.stores[0]);
          // this.redBarChart.chartData.datasets[0].data = [this.recurringcount, this.newcount];
          // this.retentionChart.chartData.datasets[0].data = Object.values(this.customerdetentiondata);
          // this.retentionChart.chartData.labels = Object.keys(this.customerdetentiondata);
      });
    Promise.all([
        store.dispatch(GET_TEAM_MEMBERS, UserService.getAssignmentId()),

      ]).then((data) => {
        console.log(data[0]['data']);
          this.loaded = true;

          // console.log(store.getters.teamMembers);
          this.teammembers = data[0]['data'];
          // this.teammembers = teamMembers;
          // console.log(this.stores);
          // console.log(this.visitsdata);
          // this.initBigChart(this.stores[0]);
          // this.redBarChart.chartData.datasets[0].data = [this.recurringcount, this.newcount];
          // this.retentionChart.chartData.datasets[0].data = Object.values(this.customerdetentiondata);
          // this.retentionChart.chartData.labels = Object.keys(this.customerdetentiondata);
      });

      if (this.userType === "committee") {
        this.participants = [{"id" : "1234", "name" : "AIGC Team", "imageUrl" : "https://cdn.iconscout.com/icon/free/png-256/user-avatar-contact-portfolio-personal-portrait-profile-6-5623.png"}];
      }
      else {
        this.participants = [{"id" : "1234", "name" : "Committee Members", "imageUrl" : "https://cdn.iconscout.com/icon/free/png-256/user-avatar-contact-portfolio-personal-portrait-profile-6-5623.png"}];
      }
  },
//   created() {
// window.addEventListener('beforeunload', this.beforeWindowUnload)
// },
//
// beforeDestroy() {
// window.removeEventListener('beforeunload', this.beforeWindowUnload)
// },
  methods: {

    confirmStayInDirtyForm() {
      return true && !this.confirmLeave()
    },

    beforeWindowUnload(e) {
      this.$router.push({ name: "login" })
      e.preventDefault();
      e.returnValue = '';
      // if (this.confirmStayInDirtyForm()) {
      //   // Cancel the event
      //   e.preventDefault()
      //   // Chrome requires returnValue to be set
      //   e.returnValue = ''
      // }
    },
    preventNav(event) {
      // if (!this.isEditing) return
      if (this.confirmStayInDirtyForm()) {
        event.preventDefault()
        event.returnValue = ""
      }
    },
    handler(event) {
      alert(event);
      event.preventDefault();
       console.log("CLOSING");
       console.log(event);
    },
    downloadItem ({ url, label }) {
    Vue.axios.get(url, { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = label
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
    },
    onSelect() {
        const file1 = this.$refs.file.files[0]
        this.file = file1;
    },
    exportHTML(){
    var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' "+
         "xmlns:w='urn:schemas-microsoft-com:office:word' "+
         "xmlns='http://www.w3.org/TR/REC-html40'>"+
         "<head><meta charset='utf-8'></head><body>";
    var footer = "</body></html>";
    var sourceHTML;
    if (this.language === 'ltr') {
      sourceHTML = header+document.getElementById("source-html").innerHTML.replace(/\n/g, "<br>")+footer;
    }else {
      sourceHTML = header+document.getElementById("source-html-ar").innerHTML.replace(/\n/g, "<br>")+footer;
    }


    var source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
    var fileDownload = document.createElement("a");
    document.body.appendChild(fileDownload);
    fileDownload.href = source;
    fileDownload.download = 'document.doc';
    fileDownload.click();
    document.body.removeChild(fileDownload);
 },
    deleteMeeting() {

      if (this.selectedEvent.id !== "") {
        let formData = {'id' : this.selectedEvent.id};
        Promise.all([
             store.dispatch(DELETE_MEETING, formData)
           ]).then((data) => {
             console.log("DATA : ");
             console.log(data);
             if (Number(data[0]['errFlag']) === 0) {
               this.selectedEvent.id = "";
               this.modals.modal0 = false;
               this.modals.modal1 = false;
               this.modals.modal2 = false;
               this.modals.modal3 = false;
               this.modals.modal14 = false;
                 if (this.language === "ltr") {
                   this.$notify({
                         type: 'success',
                         title: 'Meeting Deleted Successfully !'
                       });
                 }
                 else {
                   this.$notify({
                         type: 'success',
                         title: 'تم حذف الاجتماع بنجاح!'
                       });
                 }
                 Promise.all([
                      store.dispatch(GET_MEETINGS, UserService.getAssignmentId())
                    ]).then((data) => {
                    });


             }
         });
      }
    },
    submitEditMeeting() {
      let isTeammembersChecked = false;
      let isCommitteMembersChecked = false;
      for (let y = 0; y < this.teammembers.length; y++) {
        if (this.teammembers[y].checked) {
          isTeammembersChecked = true;
        }
      }
      for (let t = 0; t < this.committeemembers.length; t++) {
        if (this.committeemembers[t].checked) {
          isCommitteMembersChecked = true;
        }
      }

      if (this.selectedEvent.id !== "" && this.meeting_title !== "" && this.meeting_description !== "" && this.meeting_start_time !== "" && this.meeting_end_time !== "" && this.meeting_location !== "" && isCommitteMembersChecked && isTeammembersChecked) {

        if (!(new Date(this.meeting_start_time) < new Date(this.meeting_end_time))) {
          if (this.language === 'ltr') {
            this.$notify({
                    type: 'warning',
                    title: 'Meeting start time cannot be later than end time!'
                  });
          }
          else {
            this.$notify({
                    type: 'warning',
                    title: "لا يمكن أن يكون وقت بدء الاجتماع بعد وقت الانتهاء"
                  });

          }

        }
        else {
          // let startDate = new Date();
          // startDate.setHours(Number(this.meeting_start_time.split("-")[0].split(":")[0]));
          // startDate.setMinutes(Number(this.meeting_start_time.split("-")[0].split(":")[1]));
          //
          // let endDate = new Date();
          // endDate.setHours(Number(this.meeting_end_time.split("-")[0].split(":")[0]));
          // endDate.setMinutes(Number(meeting.meeting_end_time.split("-")[0].split(":")[1]));

          let stDate = new Date(this.meeting_start_time);

          stDate.setHours(stDate.getHours() + (-stDate.getTimezoneOffset()/60));

          let enDate = new Date(this.meeting_end_time);
          enDate.setHours(enDate.getHours() + (-enDate.getTimezoneOffset()/60));

          let formData = {'id' : this.selectedEvent.id, 'title' : this.meeting_title, 'description' : this.meeting_description, 'start_time' : stDate.toISOString().split("T")[1].split(".")[0], 'end_time' : enDate.toISOString().split("T")[1].split(".")[0], 'location' : this.meeting_location, 'team_members' : this.teammembers, 'committee_members' : this.committeemembers, 'date' : this.create_meeting_date, 'assignment_id' : UserService.getAssignmentId()};
          console.log(formData);
           Promise.all([
                store.dispatch(EDIT_MEETING, formData),
                store.dispatch(GET_MEETINGS, UserService.getAssignmentId()),

              ]).then(() => {
                  this.modals.modal0 = false;
                  if (this.language === 'ltr') {
                  this.$notify({
                        type: 'success',
                        title: 'Meeting Edited successfully !'
                      });
                  }

                else {
                  this.$notify({
                        type: 'success',
                        title: "تم تعديل الاجتماع بنجاح"
                      });

                }
                });
        }

     }
      else {
        if (this.language === 'ltr') {
          this.$notify({
                     type: 'warning',
                     title: 'Please fill in all required fields'
                   });
        }
        else {
          this.$notify({
                     type: 'warning',
                     title: "يرجى ملء جميع الحقول المطلوبة"
                   });

        }

      }
    },
    onChange() {

    },
    editMeeting(meeting) {
      this.isEditingMeeting = true;
      console.log("EDIT MEETING");
      console.log(meeting);
      this.meeting_title = meeting.title;
      this.meeting_description = meeting.description;
      this.meeting_location = meeting.location;
      this.create_meeting_date = meeting.datetime;
      let startDate = new Date();
      startDate.setHours(Number(meeting.startendtime.split("-")[0].split(":")[0]));
      startDate.setMinutes(Number(meeting.startendtime.split("-")[0].split(":")[1]));
      console.log("START DATE : " + startDate);
      let endDate = new Date();
      endDate.setHours(Number(meeting.startendtime.split("-")[1].split(":")[0]));
      endDate.setMinutes(Number(meeting.startendtime.split("-")[1].split(":")[1]));
      console.log("END DATE : " + endDate);
      // this.meeting_start_time = startDate;
      // this.meeting_end_time = endDate;
      for (let i =0; i < this.teammembers.length; i++) {
          if (meeting.team_members.includes(this.teammembers[i]._id)) {
            this.teammembers[i].checked = true;
          }
      }
      for (let t =0; t < this.committeemembers.length; t++) {
          if (meeting.committee_members.includes(this.committeemembers[t]._id)) {
            this.committeemembers[t].checked = true;
          }
      }
      this.modals.modal0 = true;
      this.modals.modal1 = false;
      this.modals.modal2 = false;
      this.modals.modal3 = false;




    },
    viewMeeting(meeting) {
      console.log("VIEW MEETING");
      console.log(meeting);
      this.isEditingMeeting = false;
      this.selectedEvent.id = meeting.id;
      this.selectedEvent.datetime = meeting.datetime;
      console.log(meeting.datetime);
      console.log(this.isManager);
      this.selectedEvent.team_members = meeting.team_members;
      this.selectedEvent.committee_members = meeting.committee_members;
      if (meeting.minutes) {
        this.selectedEvent.hasMinutes = true;
        this.selectedEvent.minutes = meeting.minutes;
      }
      else {
        this.selectedEvent.hasMinutes = false;
      }
      if (Number(meeting.minutes_approved) === 0) {
        this.selectedEvent.areMinutesApproved = false;
      }
      else if (Number(meeting.minutes_approved) === 1) {
        this.selectedEvent.areMinutesApproved = true;
      }
      console.log(this.selectedEvent);
      this.selectedEvent.title = meeting.title;
      this.selectedEvent.location = meeting.location;
      this.selectedEvent.startendtime = meeting.startend;
      this.selectedEvent.description = meeting.description;
      this.selectedEvent.teamMembers = meeting.team_member_names;
      this.selectedEvent.committeeMembers = meeting.committee_member_names;
      this.selectedEvent.hasFile = Number(meeting.has_file) === 1 ? true : false;
      this.selectedEvent.fileName = meeting.file_name;
      this.item.label = meeting.title;
      this.item.url = API_URL + "minutesfile/" + meeting.id;
      this.modals.modal1 = true;
    },
    switchView() {

      if (this.isCalendarView) {
        this.texts.switchview = this.texts.calendar;//UserService.getLanguage() === "ltr" ? "Calendar" : "التقويم";
      }
      else {
        this.texts.switchview = this.texts.list_of_meetings;//UserService.getLanguage() === "ltr" ? "List of Meetings" : "قائمة الاجتماعات";

      }

      this.isCalendarView = !this.isCalendarView;
    },
    downloadFile(data, fileName, type="application/pdf") {
        // Create an invisible A element
        const a = document.createElement("a");
        a.style.display = "none";
        document.body.appendChild(a);

        // Set the HREF to a Blob representation of the data to be downloaded
        a.href = window.URL.createObjectURL(
          new Blob([data], { type })
        );

        // Use download attribute to set set desired file name
        a.setAttribute("download", fileName);

        // Trigger the download by simulating click
        a.click();

        // Cleanup
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
    },
    exportMinutes () {
      this.exportHTML();
//       let pdfName = this.selectedEvent.title + " Minutes";
//       var doc = new jsPDF();
//       // doc.setFont('trado');
// //       const AmiriRegular = FONT.trim();
// //
// // doc.addFileToVFS('Amiri-Regular.ttf', AmiriRegular);
// // doc.addFont('Amiri-Regular.ttf', 'Amiri', 'normal');
// //
// // doc.setFont('Amiri'); // set font
// // doc.setFontSize(20);
// // doc.setFontSize(40);
//       console.log("lol");
//       var splitTitle = doc.splitTextToSize(this.selectedEvent.minutes, 180);
//       // doc.text(doc.processArabic(this.selectedEvent.minutes), 200, 40,{align:"right"} );
//       // doc.text(this.selectedEvent.minutes, 15, 20,{align:"right"} );
//       doc.text(this.selectedEvent.minutes, 10, 10);
//       doc.save(pdfName + '.pdf');
    },
    saveMinutes() {
      if (this.selectedEvent.minutes === "") {
        if (this.language === 'ltr') {
          this.$notify({
                  type: 'warning',
                  title: 'Meeting minutes cannot be empty!'
                });
        }
        else {
          this.$notify({
                  type: 'warning',
                  title: "لا يمكن أن تكون محضر الاجتماع فارغة"
                });

        }

      }
      else {
        if (this.file != '') {
          let formData = new FormData();
          formData.append('MoMFile', this.file);
          formData.append('id', this.selectedEvent.id);
          formData.append('minutes_text', this.selectedEvent.minutes);
          Promise.all([
               store.dispatch(SAVE_MINUTES_WITH_FILE, formData)

             ]).then((data) => {
               console.log(data);
               if (Number(data[0]) === 0) {
                 if (this.language === 'ltr') {
                   this.$notify({
                         type: 'success',
                         title: 'Minutes saved successfully !'
                       });
                 }
                 else {
                   this.$notify({
                         type: 'success',
                         title: "تم حفظ محضر الاجتماع بنجاح"
                       });

                 }

                     this.modals.modal0 = false;
                     this.modals.modal1 = false;
                     this.modals.modal2 = false;
                     this.modals.modal3 = false;
                     // this.selectedEvent = {
                     //   id : "",
                     //   title : "",
                     //   minutes : "",
                     //   description  : "",
                     //   startendtime : "",
                     //   hasMinutes : false,
                     //   areMinutesApproved : false
                     // };
                     Promise.all([
                        store.dispatch(GET_MEETINGS, UserService.getAssignmentId()),
                      ]).then((data) => {
                      });

               }
               else {
                 this.$notify({
                       type: 'warning',
                       title: data[0]['errMsg']
                     });
                   }
               });
             }

        else {
          let formData = {'id' : this.selectedEvent.id, 'minutes_text' : this.selectedEvent.minutes};
          console.log(formData);
           Promise.all([
                store.dispatch(SAVE_MINUTES, formData)

              ]).then((data) => {
                console.log(data);
                if (Number(data[0]['errFlag']) === 0) {
                  if (this.language === 'ltr') {
                    this.$notify({
                          type: 'success',
                          title: 'Minutes saved successfully !'
                        });
                  }
                  else {
                    this.$notify({
                          type: 'success',
                          title: "تم حفظ محضر الاجتماع بنجاح"
                        });

                  }

                      this.modals.modal0 = false;
                      this.modals.modal1 = false;
                      this.modals.modal2 = false;
                      this.modals.modal3 = false;
                      // this.selectedEvent = {
                      //   id : "",
                      //   title : "",
                      //   minutes : "",
                      //   description  : "",
                      //   startendtime : "",
                      //   hasMinutes : false,
                      //   areMinutesApproved : false
                      // };
                      Promise.all([
                         store.dispatch(GET_MEETINGS, UserService.getAssignmentId()),
                       ]).then((data) => {
                       });

                }
                else {
                  this.$notify({
                        type: 'warning',
                        title: data[0]['errMsg']
                      });
                    }
                });
              }
        }

    },
    approveMinutes() {
      if (this.selectedEvent.minutes === "") {
        if (this.language === 'ltr') {
          this.$notify({
                  type: 'warning',
                  title: 'Meeting minutes cannot be empty!'
                });
        }
        else {
          this.$notify({
                  type: 'warning',
                  title: "لا يمكن أن تكون محضر الاجتماع فارغة"
                });
        }

      }
      else {
        let formData = {'id' : this.selectedEvent.id, 'minutes_text' : this.selectedEvent.minutes};
        console.log(formData);
         Promise.all([
              store.dispatch(APPROVE_MINUTES, formData)

            ]).then((data) => {
              if (Number(data[0]['errFlag']) === 0) {
                if (this.language === 'ltr') {
                  this.$notify({
                        type: 'success',
                        title: 'Minutes saved and approved successfully !'
                      });
                }
                else {
                  this.$notify({
                        type: 'success',
                        title: "تم حفظ محضر الاجتماع والموافقة عليه بنجاح"
                      });
                }


                    this.modals.modal0 = false;
                    this.modals.modal1 = false;
                    this.modals.modal2 = false;
                    this.modals.modal3 = false;
                    // this.selectedEvent = {
                    //   id : "",
                    //   title : "",
                    //   minutes : "",
                    //   description  : "",
                    //   startendtime : "",
                    //   hasMinutes : false,
                    //   areMinutesApproved : false
                    // };
                    Promise.all([
                       store.dispatch(GET_MEETINGS, UserService.getAssignmentId()),
                     ]).then((data) => {
                     });
              }
              else {
                this.$notify({
                      type: 'warning',
                      title: data[0]['errMsg']
                    });
                  }

              });

      }
    },
    createMeeting() {
      if (!this.isCreatingMeeting) {
        let isTeammembersChecked = false;
        let isCommitteMembersChecked = false;
        for (let y = 0; y < this.teammembers.length; y++) {
          if (this.teammembers[y].checked) {
            isTeammembersChecked = true;
          }
        }
        for (let t = 0; t < this.committeemembers.length; t++) {
          if (this.committeemembers[t].checked) {
            isCommitteMembersChecked = true;
          }
        }

        if (this.meeting_title !== "" && this.meeting_description !== "" && this.meeting_start_time !== "" && this.meeting_end_time !== "" && this.meeting_location !== "" && isCommitteMembersChecked && isTeammembersChecked) {

          if (!(new Date(this.meeting_start_time) < new Date(this.meeting_end_time))) {
            if (this.language === 'ltr') {
              this.$notify({
                      type: 'warning',
                      title: 'Meeting start time cannot be later than end time!'
                    });
            }
            else {
              this.$notify({
                      type: 'warning',
                      title: "لا يمكن أن يكون وقت بدء الاجتماع بعد وقت الانتهاء"
                    });

            }

          }
          else {

            let startD = new Date(this.meeting_start_time);
            startD.setHours(startD.getHours() + (-startD.getTimezoneOffset()/60));

            let endD = new Date(this.meeting_end_time);
            endD.setHours(endD.getHours() + (-endD.getTimezoneOffset()/60));
            // this.meeting_end_time.setHours(this.meeting_end_time.getHours() + (-this.meeting_end_time.getTimezoneOffset()/60));

            let formData = {'title' : this.meeting_title, 'description' : this.meeting_description, 'start_time' : startD.toISOString().split("T")[1].split(".")[0], 'end_time' : endD.toISOString().split("T")[1].split(".")[0], 'location' : this.meeting_location, 'team_members' : this.teammembers, 'committee_members' : this.committeemembers, 'date' : this.create_meeting_date, 'assignment_id' : UserService.getAssignmentId()};
            console.log(formData);
            this.isCreatingMeeting = true;
             Promise.all([
                  store.dispatch(CREATE_MEETING, formData),
                  store.dispatch(GET_MEETINGS, UserService.getAssignmentId()),

                ]).then(() => {
                  this.isCreatingMeeting = false;
                    this.modals.modal0 = false;
                    if (this.language === 'ltr') {
                      this.$notify({
                            type: 'success',
                            title: 'Meeting created successfully !'
                          });
                    }
                    else {
                      this.$notify({
                            type: 'success',
                            title: "تم إنشاء الاجتماع بنجاح"
                          });

                    }

                    });
          }

       }
        else {
          if (this.language === 'ltr') {
            this.$notify({
                       type: 'warning',
                       title: 'Please fill in all required fields'
                     });
          }
          else {
            this.$notify({
                       type: 'warning',
                       title: "يرجى ملء جميع الحقول المطلوبة"
                     });

          }

        }
      }

    },
    newPublicChat() {
      this.modals.modal9 = false;
      if (Number(this.chats.length) === 0) {
        this.isNewChat = true;
        this.chatType = "public";
        document.getElementById("chat").style.visibility = "visible";
        this.openChat();
        this.chatTitle = "Public Inquiry";
        document.getElementsByClassName("sc-header--title enabled")[0].innerHTML = "Public Inquiry";
      }
      else {
        this.isNewChat = false;
        this.chatType = "public";
        document.getElementById("chat").style.visibility = "visible";
        let isChatFound = false;
        for (let i = 0 ; i < this.chats.length; i++) {
          console.log(this.chats[i]);
            if (this.chats[i].type === "public") {
              this.messageList = this.chats[i].messages;
              this.chatId = this.chats[i].id;
              this.participants = this.chats[i].participants;
              isChatFound = true;
              break;
            }
        }
        if (!isChatFound) {
          this.messageList = [];
          this.chatId = "";
          this.participants = [];
        }
        this.openChat();
        this.chatTitle = "Public Inquiry";
        document.getElementsByClassName("sc-header--title enabled")[0].innerHTML = "Public Inquiry";
      }
    },
    newPrivateChat() {
      this.modals.modal9 = false;
      if (Number(this.chats.length) === 0) {
        this.isNewChat = true;
        this.chatType = "private";
        document.getElementById("chat").style.visibility = "visible";
        this.openChat();
        this.chatTitle = "Private Inquiry";
        document.getElementsByClassName("sc-header--title enabled")[0].innerHTML = "Private Inquiry";
      }
      else {
        this.isNewChat = false;
        this.chatType = "private";
        document.getElementById("chat").style.visibility = "visible";
        let isChatFound = false;
        for (let i = 0 ; i < this.chats.length; i++) {
            if (this.chats[i].type === "private") {
              this.messageList = this.chats[i].messages;
              this.chatId = this.chats[i].id;
              this.participants = this.chats[i].participants;
              isChatFound = true;
              break;
            }
        }
        if (!isChatFound) {
          this.messageList = [];
          this.chatId = "";
          this.participants = [];
        }

        this.openChat();
        this.chatTitle = "Private Inquiry";
        document.getElementsByClassName("sc-header--title enabled")[0].innerHTML = "Private Inquiry";
      }
    },
    onClick(chat) {
      // this.isChatHidden = true;

      // document.getElementById("chatsModal").childNodes[0].childNodes[0].style = 'background-color: #ffffff;opacity: 0.0;';
      this.modals.modal9 = false;
      this.messageList = chat.messages;
      this.chatId = chat.id;
      this.participants = chat.participants;
      // this.chatType = chat.type;
      console.log(chat);
      document.getElementsByClassName("sc-header--title enabled")[0].innerHTML = chat.title;
      document.getElementById("chat").style.visibility = "visible";


      this.openChat();
    },
    openChatModal() {
      if (this.modals.modal9) {
        this.modals.modal9 = false;
      }
      else {

        Promise.all([
          store.dispatch(GET_CHATS)
        ]).then((data) => {
          console.log(data[0]['data']);
            if (data[0]['data']) {
                this.chats = data[0]['data'];
            }
            else {
              this.chats = [];
            }

            this.modals.modal9 = true;

        });

      }
    },
    sendMessage (text) {
      let formData = {'assignment_id' : UserService.getAssignmentId(), 'title' : this.chatTitle, 'text' : text, 'chat_type' : this.chatType};
      console.log(formData);
      console.log(CREATE_CHAT);
    if (text.length > 0) {
      if (this.isNewChat) {
        let formData = {'assignment_id' : UserService.getAssignmentId(), 'title' : this.chatTitle, 'text' : text, 'chat_type' : this.chatType};
        console.log(formData);
        console.log(CREATE_CHAT);
        Promise.all([
          store.dispatch(CREATE_CHAT, formData)
        ]).then(() => {
          this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
          // this.onMessageWasSent({ author: 'support', type: 'text', data: { text } });
        });
      }
      else {
        // Promise.all([
        //   store.dispatch(GET_OVERVIEW, "5e03d4c5c060d91d3c228b2a")
        // ]).then(() => {
        //   this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
        //   this.onMessageWasSent({ author: 'support', type: 'text', data: { text } });
        // });
      }

    }
  },
  onMessageWasSent (message) {
    let canSend = (this.userType === "team" && JwtService.getIsManager() === 1) || (this.userType === "committee");
    if (canSend) {
      console.log(message);
      message.author = UserService.getUserId();
      // called when the user sends a message

      let formData = {'assignment_id' : UserService.getAssignmentId(), 'title' : this.chatTitle, 'text' : message.data.text, 'chat_type' : this.chatType};
      console.log(formData);
      console.log(CREATE_CHAT);
      if (message.data.text.length > 0) {
      if (this.isNewChat) {
        let formData = {'assignment_id' : UserService.getAssignmentId(), 'title' : this.chatTitle, 'text' : message.data.text, 'chat_type' : this.chatType};
        console.log(formData);
        console.log(CREATE_CHAT);
        Promise.all([
          store.dispatch(CREATE_CHAT, formData)
        ]).then((data) => {
          this.chatId = data[0]['chatId'];
          this.isNewChat = false;
          this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
          message.author = "me";
          this.messageList = [ ...this.messageList, message ]
          // this.onMessageWasSent({ author: 'support', type: 'text', data: { text } });
        });
      }
      else {
        message.author = UserService.getUserId();
        let formData = {'assignment_id' : UserService.getAssignmentId(), 'chat_id' : this.chatId,  'text' : message.data.text, 'chat_type' : this.chatType};
        console.log(formData);
        console.log(SEND_MESSAGE);
        Promise.all([
          store.dispatch(SEND_MESSAGE, formData)
        ]).then(() => {
          this.isNewChat = false;
          this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
          message.author = "me";
          this.messageList = [ ...this.messageList, message ]
          // this.onMessageWasSent({ author: 'support', type: 'text', data: { text } });
        });
        // Promise.all([
        //   store.dispatch(GET_OVERVIEW, "5e03d4c5c060d91d3c228b2a")
        // ]).then(() => {
        //   this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + 1
        //   this.onMessageWasSent({ author: 'support', type: 'text', data: { text } });
        // });
      }

      }
    }

  },
  openChat () {
    // called when the user clicks on the fab button to open the chat
    this.isChatOpen = true
    this.newMessagesCount = 0

    // document.getElementById("chat").childNodes[1].style['margin-right'] = '100px';
    // if (document.getElementById("chat").childNodes[1].childNodes) {
    //   console.log("FOUND CHILD NODES");
    //   // console.log(document.getElementById("chat").childNodes[1].childNodes);
    //   for (let i =0 ; i < document.getElementById("chat").childNodes[1].childNodes.length; i++) {
    //     // console.log(document.getElementById("chat").childNodes[1].childNodes[i]);
    //     if (i == 1) {
    //       console.log(document.getElementById("chat").childNodes[1].childNodes[i]);
    //       for (let g = 0; g < document.getElementById("chat").childNodes[1].childNodes[i].childNodes.length; g++) {
    //         document.getElementById("chat").childNodes[1].childNodes[i].childNodes[g].style = 'margin-right : 100px';
    //       }
    //
    //     }
    //     if (document.getElementById("chat").childNodes[1].childNodes[i].style) {
    //         document.getElementById("chat").childNodes[1].childNodes[i].style['margin-right'] = '100px';
    //     }
    //     else {
    //       document.getElementById("chat").childNodes[1].childNodes[i].style = 'margin-right : 100px';
    //     }
    //
    //   }
    // }
    // else {
    //   console.log("NO CHILD NODES");
    // }
  },
  closeChat () {
    // called when the user clicks on the botton to close the chat
    this.isChatOpen = false
  },
  handleScrollToTop () {
    // called when the user scrolls message list to top
    // leverage pagination for loading another page of messages
  },
  handleOnType () {
    console.log('Emit typing event')
  },
  editMessage(message){
    const m = this.messageList.find(m=>m.id === message.id);
    m.isEdited = true;
    m.data.text = message.data.text;
  },

    handleOpenChange(open) {
        console.log('open', open);
        this.open = open;
      },
      handleClose() {
        this.open = false;
        this.open2 = false;
      },
    handleDateClick(arg) {
      // console.log(arg);
      if (Number(JwtService.getIsManager()) === 1) {
        if (!(new Date(arg.dateStr) < new Date())) {
          this.create_meeting_date = arg.dateStr;
          this.meeting_title = "";
          this.meeting_location = "";
          this.meeting_description = "";
          this.meeting_start_time = "";
          this.meeting_end_time = "";
          for (let y =0; y < this.teammembers.length; y++) {
              this.teammembers[y].checked = false;
          }
          for (let g =0; g < this.committeemembers.length; g++) {
              this.committeemembers[g].checked = false;
          }
          this.modals.modal0 = true;
        }
      }
      // alert(arg)
    },
    meetingClick(meeting) {
      console.log(meeting);
      console.log("MEETING CLICK");
      // console.log(this.userType);
      //

      // this.selectedEvent = {
      //   id : "",
      //   title : "",
      //   minutes : "",
      //   description  : "",
      //   startendtime : "",
      //   hasMinutes : false,
      //   areMinutesApproved : false
      // };
      this.selectedEvent.team_members = meeting.team_members;
      this.selectedEvent.committee_members = meeting.committee_members;
      this.selectedEvent.datetime = meeting.datetime;

      console.log(meeting.datetime);
      console.log(this.isManager);

      this.selectedEvent.id = meeting.id;
      if (meeting.minutes) {
        this.selectedEvent.hasMinutes = true;
        this.selectedEvent.minutes = meeting.minutes;
      }
      else {
        this.selectedEvent.hasMinutes = false;
      }
      if (Number(meeting.minutes_approved) === 0) {
        this.selectedEvent.areMinutesApproved = false;
      }
      else if (Number(meeting.minutes_approved) === 1) {
        this.selectedEvent.areMinutesApproved = true;
      }
      console.log(this.selectedEvent);
      this.selectedEvent.title = meeting.title;
      this.selectedEvent.location = meeting.location;
      this.selectedEvent.startendtime = meeting.startend;
      this.selectedEvent.description = meeting.description;
      this.modals.modal1 = true;
      // console.log(arg.event);
    },
    eventClick(arg) {

      console.log(arg);
      console.log(this.userType);

      this.selectedEvent.id = arg.event.id;
      if (arg.event.extendedProps.minutes) {
        this.selectedEvent.hasMinutes = true;
        this.selectedEvent.minutes = arg.event.extendedProps.minutes;
      }
      else {
        this.selectedEvent.hasMinutes = false;
      }
      if (Number(arg.event.extendedProps.minutes_approved) === 0) {
        this.selectedEvent.areMinutesApproved = false;
      }
      else if (Number(arg.event.extendedProps.minutes_approved) === 1) {
        this.selectedEvent.areMinutesApproved = true;
      }
      console.log(this.selectedEvent);
      this.selectedEvent.title = arg.event.title;
      this.selectedEvent.location = arg.event.extendedProps.location;
      this.selectedEvent.startendtime = arg.event.extendedProps.startend;
      this.selectedEvent.datetime = arg.event.extendedProps.datetime;
      this.selectedEvent.description = arg.event.extendedProps.description;
      this.modals.modal1 = true;
      console.log(arg.event);
    },
    minutesClick() {
      // this.modals.modal1 = false;
      this.modals.modal2 = true;
    }
  }
}

</script>

<style lang='scss'>

@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';
@import '~@fullcalendar/timegrid/main.css';

</style>
